<template>
  <VanPopup
    v-model:show="homeStore.showAddModal"
    :z-index="998"
    class="home-add-content p-5 pb-24 bg-base-100"
    overlay-class="home-add-overlay"
    position="bottom"
    round
  >
    <div>
      <!-- 制作工具 -->
      <div class="flex justify-between text-base-content/50 items-center">
        <p class="text-lg">{{ $t(`MineMate.tools`) }}</p>
        <span class="px-1 cursor-pointer" @click="clickItem(taskItem)">
          {{ $t(`MineMate.queue`) }} >
        </span>
      </div>

      <div class="w-full h-full grid grid-cols-4 mt-4 mb-9">
        <div
          v-for="item in toolsList"
          :key="item.name"
          class="flex flex-col h-full justify-center items-center gap-1.5 cursor-pointer"
          @click="clickItem(item)"
        >
          <i :class="['iconify', item.icon]" />
          <span class="whitespace-nowrap">
            {{ $t(item.name) }}
          </span>
        </div>
      </div>

      <!-- 创作与发布 -->
      <div class="flex justify-between text-base-content/50 items-center">
        <p class="text-lg">{{ $t(`MineMate.create`) }}</p>
        <span class="px-1 cursor-pointer" @click="clickItem(earnItem)">
          {{ $t(`MineMate.earn`) }} >
        </span>
      </div>

      <div class="w-full h-full grid grid-cols-4 gap-5 mt-4">
        <div
          v-for="item in createList"
          :key="item.name"
          class="flex flex-col h-full justify-center items-center gap-1.5 cursor-pointer"
          @click="clickItem(item)"
        >
          <i :class="['iconify', item.icon]" />
          <span class="whitespace-nowrap">
            {{ $t(item.name) }}
          </span>
        </div>
      </div>
    </div>
  </VanPopup>
  <CreateImageModeModal v-model:show="showSelectPainting" />
</template>

<script lang="ts" setup>
import { useHome } from "@/stores/home";
import { useMate } from "@/stores/mate";
import { ref } from "vue";
import { useRouter } from "vue-router";

const mateStore = useMate();
const router = useRouter();
const homeStore = useHome();
const toolsList = [
  {
    name: "MineMate.portrait",
    icon: "mingcute--emoji-line",
    path: "/generation/trait/list",
  },

  {
    name: "MineMate.imageWorkshop",
    icon: "mingcute--magic-3-line",
    // path: `/generation/image/create`,
    action: () => {
      showSelectPainting.value = true;
    },
  },
];
const createList = [
  {
    name: "MineMate.post",
    icon: "mingcute--quill-pen-line",
    path: "/thread/create",
  },

  {
    name: "MineMate.story",
    icon: "mingcute--book-4-line",
    path: "/story/list",
  },

  {
    name: "MineMate.game",
    icon: "mingcute--game-2-line",
    path: "/game",
  },

  {
    name: "collection.name",
    icon: "mingcute--version-line",
    path: "/collection/list",
  },
];
const taskItem = {
  name: "MineMate.task",
  path: "/generation/image/list",
};
const earnItem = {
  name: "MineMate.earn",
  path: "/transaction",
};
const clickItem = (item: any) => {
  let { path, action, name } = item;
  if (name === "MineMate.profile")
    path = `/mate/profile/edit/${mateStore.currentMate?.uuid}#1`;
  path ? router.push(path) : action!();
  homeStore.showAddModal = false;
};

// select trait/image
const showSelectPainting = ref(false);
</script>

<style>
.home-add-overlay {
  @apply h-[calc(100%-100px)] sm:h-full;
}
</style>
